/**
 * Test database connectivity
 */

export async function testIndexedDB(): Promise<{
  supported: boolean;
  canCreate: boolean;
  error?: string;
}> {
  // Test 1: Check if IndexedDB is supported
  if (!window.indexedDB) {
    return {
      supported: false,
      canCreate: false,
      error: "IndexedDB is not supported in this browser",
    };
  }

  // Test 2: Try to create a test database
  try {
    await new Promise<void>((resolve, reject) => {
      const request = indexedDB.open("__test_db__", 1);

      request.onsuccess = () => {
        const db = request.result;
        db.close();
        indexedDB.deleteDatabase("__test_db__");
        resolve();
      };

      request.onerror = () => {
        reject(new Error("Failed to open test database"));
      };

      request.onblocked = () => {
        reject(new Error("Database creation blocked"));
      };

      request.onupgradeneeded = () => {
        const db = request.result;
        db.createObjectStore("test", { keyPath: "id" });
      };
    });

    return {
      supported: true,
      canCreate: true,
    };
  } catch (error) {
    return {
      supported: true,
      canCreate: false,
      error: error instanceof Error ? error.message : "Unknown error",
    };
  }
}
